import styled from 'styled-components';

interface ContainerProps {
  $fullWidth?: boolean;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  ${({ $fullWidth }) => $fullWidth && 'width: 100%;'}
`;

export const Label = styled.label`
  font-size: 18px;
  font-weight: 500;
  color: ${({ theme }) => theme.text};
  margin-bottom: 8px;
`;

export const RequiredStar = styled.span`
  color: ${({ theme }) => theme.error};
  margin-left: 4px;
`;

export const ErrorText = styled.p`
  font-size: 13px;
  font-weight: 500;
  color: ${({ theme }) => theme.error};
  margin-top: 6px;
  margin-bottom: 0;
`;
